exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nfigure.logo[data-v-b6c062f8] {\n  display: inline-block;\n  height: 10em;\n  width: 10em;\n}\nfigure.logo figcaption[data-v-b6c062f8] {\n  text-align: center;\n}\n", ""]);

